import "./SubscriptionChannelPrice.scss";

import { useTranslation } from "react-i18next";

interface ISubscriptionChannelPrice {
    subscriptionCoefficient?: number | string;
}

const SubscriptionChannelPrice = ({ subscriptionCoefficient }: ISubscriptionChannelPrice) => {
    const [t] = useTranslation();

    return (
        <span className="subscription-channel-coefficient">
            {t("Subscription.Coefficient")} : {subscriptionCoefficient ?? "-"}
        </span>
    );
};

export default SubscriptionChannelPrice;
